const meta = {
  description:
    "BTC Central warehouse a new modern central warehouse in the center of Slovenia. At the junction of regional and international supply routes.",
  title: "BTC Logistics Center Zalog",
};

export default meta;
